import React from 'react';
import {getDescriber} from '../../descriptor/DescriptorType';
import {Modal, View} from 'react-native';
import AVTouchableOpacity from '../../../../elements/AVTouchableOpacity';
import Localized from '../../../../../constants/AppStrings';
import Styles from '../../../../Styles';
import CancelIcon from '../../../../img/svg/CancelIcon';
import AVText from '../../../../elements/AVText';
import {getDescriber as getSnackDescriber} from '../../../sendSnack/descriptor/sendasnack/DescriptorType';
import RoundedAppButton, {
  RoundedAppButtonType,
} from '../../../../elements/RoundedAppButton';
import {getButtonDescriber} from '../../../../elements/buttonDescriptor/DescriptorType';
import {helpScreenStyles} from '../styles';

export const ErrorModal: React.FC<{
  visible: boolean;
  onClose: () => void;
}> = ({visible, onClose}) => {
  const {getHelpStyleDescriptor} = getDescriber();

  if (!visible) {
    return null;
  }

  return (
    <Modal visible={true} onDismiss={onClose} transparent={true}>
      <View style={helpScreenStyles.modalMain}>
        <View style={helpScreenStyles.modalContainer}>
          <AVTouchableOpacity
            aria-label={`X icon, Double tap to ${Localized.Buttons.cancel} offer details`}
            role="button"
            style={helpScreenStyles.closeModalTitleContainer}
            onPress={onClose}
            accessible
            accessibilityLabel={Localized.Buttons.cancel}
            accessibilityRole="button"
            hitSlop={Styles.HitSlop_10}
          >
            <CancelIcon />
          </AVTouchableOpacity>

          <View style={helpScreenStyles.modalContentContainer}>
            <AVText
              aria-label={`${Localized.Success.delete_Acnt} label, text`}
              accessibilityLabel={`${Localized.Success.delete_Acnt} label`}
              style={[
                getHelpStyleDescriptor()?.helpErrTitle,
                getSnackDescriber().snackDetailsBtnFontSTyle(),
              ]}
              accessible={true}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
            >
              {Localized.Labels.err_send_email}
            </AVText>

            <AVText
              accessible={true}
              accessibilityLabel={`${Localized.Success.delete_acnt_desc} label`}
              aria-label={`${Localized.Success.delete_acnt_desc} label, text`}
              style={[
                getHelpStyleDescriptor()?.helpErrDesc,
                getSnackDescriber().snackDetailsBtnFontSTyle(),
              ]}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
            >
              {Localized.Labels.err_send_desc}
            </AVText>
          </View>

          <View>
            <RoundedAppButton
              buttonType={RoundedAppButtonType.Solid}
              onPress={onClose}
              buttonViewStyle={{
                overflow: 'hidden',
                borderWidth: 2,
                borderRadius: 32,
                backgroundColor: getButtonDescriber().checkRoundedBtnColor(),
                borderTopColor: getButtonDescriber().checkRoundedBtnColor(),
                borderBottomColor: getButtonDescriber().checkRoundedBtnColor(),
                borderLeftColor: getButtonDescriber().checkRoundedBtnColor(),
                borderRightColor: getButtonDescriber().checkRoundedBtnColor(),
                borderColor: getButtonDescriber().checkRoundedBtnColor(),
                width: 100,
                height: 42,
              }}
              buttonContainerStyle={{
                alignSelf: 'center',
                marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
              }}
              accessibilityLabelValue={Localized.Buttons.okay}
              titleText={Localized.Buttons.okay}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
              textStyle={getHelpStyleDescriptor()?.errBtn}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};
